// ordersData.js

const cafeId = "e7b20008-f754-402a-944c-027bf11d68c0";

export const getOrdersData = async () => {
  try {
    const response = await fetch(
      `https://fliplyn-b-c.fly.dev/orders/cafe/?cafe_id=${cafeId}&time_range_minutes=1440`,
      {
        headers: {
          accept: "application/json"
        }
      }
    );

    const data = await response.json();

    const transformedOrders = data.map((order, index) => {
      const createdAt = new Date(order.created_at);

      return {
        id: order.id || `ORD-${index + 1}`,
        table: `T-${order.table_number}`,
        name: order.user_name,
        phone: order.user_phone,
        guests: order.number_of_guests,
        time: Math.floor(
          (Date.now() - createdAt.getTime()) / (1000 * 60)
        ),
        status: order.order_status,
        orderTime: createdAt.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit"
        }),
        items: order.order_items.map((item) => ({
          name: item.item_name,
          qty: item.quantity,
          price: Number(item.total_amount)
        })),
        billing: {
          net: Number(order.net_amount),
          cgst: Number(order.cgst),
          sgst: Number(order.sgst),
          round: Number(order.round_off),
          total: Number(order.total_amount_to_pay)
        }
      };
    });

    return transformedOrders;

  } catch (error) {
    console.error("Failed to fetch orders:", error);
    return [];
  }
};